export const TRIAL_QUESTION_COUNT = 5;
